var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.alignment},[_c('w-btn',_vm._g({staticClass:"mt-3 pl-0",attrs:{"color":"primary","disabled":_vm.disabled,"text":"","changes-form":"","min-width":"100px","data-test-id":"add-to-list-button"}},_vm.$listeners),[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }